<template>
  <div class="block header two-col">
    <slot />
    <div class="field text-field">
      <label class="label"><br>— Intro text</label>
      <div class="control">
        <input class="input" type="text" placeholder="Intro title/text" v-model="data.introText" v-on:input="update">
      </div>
    </div>
    <div class="field">
      <label class="label"><br>— Background video</label>
      <Edit-VideoBlock key="introBackgroundVideo" :data="data.videos" v-on:updateBlock="update" />
    </div>
    <div class="field">
      <label class="label"><br>— Background images</label>
      <Edit-ImageBlock key="introBackgroundImages" :data="data.images" v-on:updateBlock="update" />
    </div>
    <div class="row">
      <div class="field">
        <label class="label"><br>— Logo</label>
        <Edit-ImageBlock key="introLogo" :data="data.introLogo" singleOnly="true" v-on:updateBlock="update" />
      </div>
      <div class="field">
        <label>Logo position</label>
        <div class="control">
          <select v-model="data.classNames" @change="update">
            <option value="logo-bottom">Bottom</option>
            <option value="logo-center">Center</option>
            <option value="logo-top">Top</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'
import { VueEditor } from 'vue2-editor'
import _ from 'lodash'
import crypto from 'crypto'
import FileUploader from '@/components/FileUploader'
import EditImageBlock from '@/components/Edit-ImageBlock'
import EditVideoBlock from '@/components/Edit-VideoBlock'

export default {
  name: 'Edit-IntroBlock',
  props: ['data'],
  components: {
    VueEditor,
    FileUploader,
    EditImageBlock,
    EditVideoBlock
  },
  methods: {
    update: function() {
      this.$emit('updateBlock', this.data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .header .nested {
    display: none;
  }
  .header .text-field {
    flex: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Edit-IntroBlock.vue